import { WsBaseRequest } from 'api/ws/WsRequest';
import { API_TOURNAMENT_REMOVE } from 'api/notificationManager/methods';

export default class TournamentRemoveRequest extends WsBaseRequest {
  constructor(tournamentID: number) {
    super(API_TOURNAMENT_REMOVE, { id: tournamentID });
  }
}
